<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper" v-if="Object.keys(reportData).length">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="contact-head">
            <div class="row align-items-center">
              <div class="col-sm-6">
                <ul class="contact-breadcrumb">
                  <li>
                    <router-link to="/crm/reports-list">
                      <i class="ti ti-arrow-narrow-left"></i> List
                    </router-link>
                  </li>
                  <!-- <li>Edit Reports</li> -->
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="card">
                <div class="card-body settings-form">
                  <!-- Iterate over formGroups if present -->
                  <div class="row align-items-center mb-4" v-if="formData.filters.length > 0">
                    <!-- <div class="col-md-6">
                      <h3 v-if="!isEditing1" class="col-md-12" @click="toggleEdit">
                        {{ formData.name }}
                        <small v-if="filterData.name">({{ filterData.name }})</small>
                      </h3>
                      <div v-else class="col-md-6">
                        <select v-model="filterData.name" class="select form-select" @change="handleChange">
                          <option v-for="(label, value) in settingData.modules" :key="label.id" :id="label.id">
                            {{ label.name }}
                          </option>
                        </select>
                      </div>
                    </div> -->

                    <div class="col-md-6" ref="selectWrapper">
                      <h3 v-if="!isEditing1" class="col-md-12">
                        <span class="report-module" @click="toggleEdit">{{ formData.name }}
                        <small v-if="filterData.name">({{ filterData.name }})</small></span>
                      </h3>

                      <div v-else class="col-md-6">
                        <select v-model="filterData.name" class="select form-select" @change="handleChange">
                          <option v-for="label in settingData.modules" :key="label.id" :id="label.id">
                            {{ label.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-6 text-end mt-3 mt-md-0 ">
                      <router-link :to="{
                        path: '/crm/report-chart',
                        query: {
                          modN: filterData?.name,
                          repN: formData?.name,
                          reportId: route.query?.reportId,
                          moduleId: route.query?.moduleId,
                          type: chart?.type,
                          field_id: chart?.field_id,
                        },
                      }" class="btn btn-light me-3">Chart</router-link>
                      <button class="btn btn-light report-btn" @click="handleReport">
                        Report
                      </button>
                      <button type="submit" class="btn btn-primary" @click="handleSubmit" :disabled="toggle">
                        Update
                      </button>
                    </div>
                    <div class="col-md-6 my-3">
                      <button :class="['btn me-3', { active: !toggle }]" @click="handleToggleFilter">
                        Data Filter
                      </button>
                      <button :class="['btn chart-btn', { active: toggle }]" @click="handleToggleChart">
                        Chart
                      </button>
                    </div>
                  </div>
                  <Form class="toggle-height" v-if="!toggle">
                    <div class="pro-create">
                      <div v-for="(group, groupIndex) in formData.filters" :key="groupIndex" class="mb-3">
                        <div v-if="groupIndex > 0">
                          <hr />
                          <div class="pb-3"><strong>And Condition</strong></div>
                        </div>
                        <div v-for="(row, rowIndex) in group" :key="rowIndex">
                          <div class="row mx-0">
                            <div class="col-md-3 col-12">
                              <div :class="[
                                'form-wrap',
                                {
                                  'is-invalid':
                                    !row.field_id && formSubmitted,
                                },
                              ]">
                                <treeselect v-model="row.field_id" :options="module_data" :disable-branch-nodes="true" :key="treeselectKey"
                                  :show-count="true"
                                  @select="(selectedNode) => handleSelectChange(groupIndex, rowIndex, selectedNode)"
                                  placeholder="Choose field...." />
                              </div>

                              <div v-if="!row.field_id && formSubmitted" class="invalid-feedback">
                                Field is required.
                              </div>
                            </div>

                            <!-- Condition Dropdown -->
                            <div class="col-md-3 col-sm-4 col-12">
                              <div class="form-wrap" :class="{
                                'is-invalid': !row.condition && formSubmitted,
                              }">
                                <select v-model="row.condition" class="form-select custom_form_select py-0"
                                  :disabled="!row.field_id">
                                  <option value="">Choose condition...</option>
                                  <option v-for="(
                                      label, value
                                    ) in row.criteria_options" :key="label" :value="value">
                                    {{ label }}
                                  </option>
                                </select>
                              </div>
                              <!-- Error message for condition -->
                              <div v-if="!row.condition && formSubmitted" class="invalid-feedback">
                                Condition is required.
                              </div>
                            </div>

                            <div class="col-md-3 col-sm-4 col-12" v-if="row.condition !== 'blank'  && row.condition !== 'not_blank'">
                              <div class="form-wrap" :class="{
                                'is-invalid': !row.value && formSubmitted,
                              }">
                                <div v-if="
                                  row.fieldType === 'dropdown' &&
                                  row.dropdown_options && row.field !== 'opp_sales_contact'
                                ">
                                  <select class="form-select form-control custom_form_select py-0" v-model="row.value">
                                    <option value="">-----Select-----</option>
                                    <option v-for="option in row.dropdown_options" :key="option.value || option.id"
                                      :value="option.value || option.id">
                                      {{ option.text || option.name || option.country_name }}
                                    </option>
                                  </select>
                                </div>
                                <div v-else-if="
                                  row.fieldType === 'dropdown' &&
                                  row.dropdown_options && row.field === 'opp_sales_contact'
                                ">
                                  <select class="form-select form-control custom_form_select py-0" v-model="row.value">
                                    <option value="">-----Select-----</option>
                                    <option value="Unknown">Unknown</option>
                                  </select>
                                </div>
                                <div v-else-if="row.fieldType === 'text' || row.fieldType === 'none'">
                                  <input type="text" placeholder="Enter value"
                                    class="form-control custom_form_select py-0" v-model="row.value
                                      " />
                                </div>

                                <div v-else-if="row.fieldType === 'checkbox'" class="py-3-5">
                                  <input type="checkbox" class="form-check custom_form_select" :true-value="1"
                                    :false-value="0" v-model="row.value
                                      " />
                                </div>

                                <div v-else-if="row.fieldType === 'textarea'">
                                  <textarea class="form-control custom_form_select py-0" v-model="row.value
                                    "></textarea>
                                </div>
                                <div v-else-if="row.fieldType === 'datepicker'">
                                  <div class="row align-items-center">
                                    <div class="col-10">
                                      <div class="icon-form"
                                        v-if="!row.special && row.specialSelected !== 'blank' && row.specialSelected !== 'current' && row.specialSelected !== 'currentAddjust' && row.specialSelected === 'spec_date'">
                                        <date-time-picker
                                          v-model="row.value"
                                          text-input
                                          format="dd/MM/yyyy"
                                          auto-apply
                                          :enable-time-picker="false"
                                          :disabled=false
                                          :clearable=true
                                          @update:modelValue="handleDateChange($event, row)"
                                        />
                                      </div>
                                      <div class="col"
                                        v-if="(row.special && row.specialSelected !== 'currentAddjust') || (!row.special && row.specialSelected === 'blank') || (!row.special && row.specialSelected === 'current') || (!row.special && row.specialSelected !== 'spec_date' && row.specialSelected !== 'currentAddjust')">
                                        <select v-model="row.specialSelected" class="form-select"
                                          @change="changeValue(groupIndex, rowIndex)">
                                          <option value="" selected>Select</option>
                                          <option value="spec_date">Specific date</option>
                                          <option value="blank">Blank date</option>
                                          <option value="current">Current date</option>
                                          <option value="currentAddjust">Current date +/-</option>
                                        </select>
                                      </div>
                                      <div
                                        v-if="(row.special && row.specialSelected === 'currentAddjust') || row.specialSelected === 'currentAddjust'">
                                        <div class="row align-items-center">
                                          <div class="col-6">
                                            <label class="mb-0 text-muted">Today +/-</label>
                                          </div>
                                          <div class="col-6">
                                            <div class="row align-items-center">
                                              <div class="col-3 p-0">
                                                <button @click="adjustDate(-1,groupIndex,rowIndex, $event)" class="btn btn-teal w-100"><i
                                                    class="ti ti-minus"></i></button>
                                              </div>
                                              <div class="col-6 p-0">
                                                <input type="number" v-model="row.adjustValue"
                                                  class="form-control text-center" placeholder="0" />
                                              </div>
                                              <div class="col-3 p-0">
                                                <button @click="adjustDate(1,groupIndex,rowIndex, $event)" class="btn btn-teal w-100"><i
                                                    class="ti ti-plus"></i></button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-2">
                                      <a href="javascript:void(0)"
                                        v-if="!row.special || row.specialSelected === 'currentAddjust'" @click="toggleSpecial(groupIndex, rowIndex)"
                                        class="text-muted">
                                        <span class="form-icon" style="font-size: 25px;"><i
                                            class="ti ti-calendar-check"></i></span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div v-if="!row.value && formSubmitted" class="invalid-feedback">
                                Value is required.
                              </div>
                            </div>
                            <div class="col-md-3 col-sm-4 col-12" v-else></div>


                            <!-- Prompt User Checkbox & Remove Row Button -->
                            <div class="col-md-3 col-sm-4 col-12">
                              <div class="d-flex justify-content-around">
                                <div class="check-input">
                                  <input type="checkbox" class="form-check-input" :checked="row.prompt_user === 1"
                                    :disabled="!row.field_id" @change="togglePromptUser(row)" />
                                  <label for="checkbox">Prompt user</label>
                                </div>

                                <!-- Remove Row Button -->
                                <button v-if="
                                  formData.filters.length > 1 ||
                                  formData.filters.some((g) => g.length > 1)
                                " @click.prevent="
                                  removeRow(groupIndex, rowIndex)
                                  " class="cross-btn">
                                  <i data-v-505522fa="" class="ion-close-round text-danger" data-bs-toggle="tooltip"
                                    title="Delete Row"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <button class="btn btn-light me-3" @click.prevent="addRowToGroup(groupIndex)">
                            ➕ Or
                          </button>
                          <button class="btn btn-light" v-if="groupIndex === formData.filters.length - 1"
                            @click.prevent="addGroup">
                            ➕ And
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>

                  <Form class="toggle-height" v-if="toggle">
                    <div class="pro-create">
                      <div class="mb-3">
                        <div class="row">
                          <div class="col-md-6 d-flex align-items-center">
                            <label class="col-md-3 mb-0">Split by data field:</label>
                            <div class="col-md-9">
                              <treeselect v-model="chart.field_id" :options="module_data" :disable-branch-nodes="true"
                                :show-count="true" @select="(selectedNode) => handleChartChange(selectedNode)"
                                placeholder="Choose field...." />
                            </div>
                          </div>

                          <div class="col-md-6 d-flex align-items-center">
                            <label class="col-md-3 mb-0">Chart type:</label>
                            <div class="col-md-9">
                              <select v-model="chart.type" class="form-select">
                                <option value="column" selected>Columns</option>
                                <option value="line">Line</option>
                                <option value="pie">Pie Chart</option>
                                <option value="bar">Funnel</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-else-if="showFallback">
    <div class="col-md-12">
      <no-data-found />
  </div>
</div>
  <div ref="addReportsModal" class="modal fade" id="confirm_modal" tabindex="-1" role="dialog"
    aria-labelledby="addReportsLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-end">
          <button class="btn-close" id="close-btn" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body confirm">
          <h3>Confirm Change Overview Type ?</h3>
          <p>Can remove data filters and displayed data</p>
          <button class="btn btn-primary confirm-btn" @click="confirm_change">
            Confirm
          </button>
          <button class="btn btn-outline-secondary cancel-btn" @click="cancel_change">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import Treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";

export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    Treeselect,
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const report_id = ref(null);
    const isEditing = ref(false);
    const filterData = ref({});
    const dateFormat = "dd/MM/yyyy";
    const formData = ref({
      filters: [],
    });
    const treeselectKey = ref(0);
    const settingData = ref([]);
    const selectedData = ref([]);
    const showFallback = ref(false)
    const reportData = ref({})
    const toggle = ref(false);
    const chart = ref({
      field_id: null,
      type: "column",
    });
    const module_data = ref([]);

    const value = ref(null);

    const isEditing1 = ref(false);
    const selectedOption = ref("User");

    const selectWrapper = ref(null)

    const toggleEdit = async () => {
      isEditing1.value = true;
      const settingsData1 = await store.dispatch("report/fetchDropdownOptions");
      settingData.value = settingsData1;
      nextTick(() => {
        document.addEventListener('click', handleClickOutside)
      })
    };

    const filters = ref({
      field_id: null,
      condition: "",
      value: "",
      prompt_user: false,
      fieldType: "none",
      field:"",
      critera_options:{}
    });

    const settingField = ref({});
    const selectedField = ref("");
    const selectedCondition = ref("");
    const formSubmitted = ref(false);
    const selectedModule = ref(null);
    // const special = ref(false);
    // const specialSelected = ref('spec_date');
    // const adjustValue = ref(0);

    const initialModuleValue = ref("");

    const toggleSpecial = (groupIndex,rowIndex) => {
      // specialSelected.value = '';
      // special.value = !special.value;
      formData.value.filters[groupIndex][rowIndex].specialSelected = '';
      formData.value.filters[groupIndex][rowIndex].special = !formData.value.filters[groupIndex][rowIndex].special;
      formData.value.filters[groupIndex][rowIndex].value = null;
    };
    const changeValue = (groupIndex, rowIndex) => {
      const specialSelected =  formData.value.filters[groupIndex][rowIndex].specialSelected;
      if (specialSelected === 'currentAddjust') {
        // special.value = true;
        formData.value.filters[groupIndex][rowIndex].special = true;
      } else if (specialSelected === 'spec_date') {
        // special.value = false;
        formData.value.filters[groupIndex][rowIndex].special = false;
        formData.value.filters[groupIndex][rowIndex].value = null;
      } else if (specialSelected === ''){
        formData.value.filters[groupIndex][rowIndex].value = null;
      }
    }
    const adjustDate = (amount,groupIndex,rowIndex, event) => {
      event.preventDefault(); // Prevent default behavior
      // if (adjustValue.value + amount >= 0) {
      // adjustValue.value += amount;
      formData.value.filters[groupIndex][rowIndex].adjustValue += amount;
      // }
    };

    const handleSubmit = async (flag) => {
      formSubmitted.value = true;
      formData.value.filters.forEach(group => {
        group.forEach(row => {
          if (row.fieldType === 'datepicker') {
            if (row.specialSelected === 'blank') {
              row.value = row.specialSelected; // Clear the date
            } else if (row.specialSelected === 'current') {
              row.value = row.specialSelected; // Set current date
            } else if (row.specialSelected === 'currentAddjust') {
              if (row.adjustValue >= 0) {
                row.value = `current+${row.adjustValue}`;
              } else {
                row.value = `current${row.adjustValue}`; // This works for negative numbers (e.g., current-4)
              }
            }
          }
        });
      });
      if (isFormValid()) {
        const updatedData = {
          ...formData.value,
          filters: formData.value.filters.map(group =>
            group.map(({ fieldType, dropdown_options, specialSelected, adjustValue, special, criteria_options, ...rest }) => rest)
          ),
          // updated_at: changeFormate(formData.value.updated_at),
        };
        const response = await store.dispatch(
          "report/saveReportData",
          updatedData
        );
        if (response.status) {
          // formData.value = { filters: [] };
          const reportId = route.query.reportId;
          const moduleId = route.query.moduleId;
          router.push({
            path: "/crm/report-edit",
            query: {
              reportId: reportId,
              moduleId: moduleId,
            },
          });
          if (flag) {
            await fetchReportData(reportId);
          }
        }
      }
    };

    // const isFormValid = () => {
    //   return formData.value.filters.every((group) =>
    //     group.every((row) => !!row.value && !!row.condition)
    //   );
    // };

    const isFormValid = () => {
      return formData.value.filters.every((group) =>
        group.every((row) => {
          if (row.condition === "blank" || row.condition === "not_blank") {
            return true;
          }
          return !!row.value && !!row.condition;
        })
      );
    };

    const togglePromptUser = (row) => {
      row.prompt_user = row.prompt_user === 1 ? 0 : 1;
    };

    const fetchModuleData = async (id) => {
      try {
        const data = await store.dispatch("report/fetchModuleData", id);
        module_data.value = data;
        chart.value = {
          field_id: module_data.value?.[0]?.children?.[0]?.id,
          type: "column",
        };
      } catch (error) {
        console.error("Error fetching report data:", error);
      }
    };

    const getModuleFields = (moduleId) => {
      const module = module_data.value.find((mod) => mod.id === moduleId);
      return module ? module.module_fields : [];
    };

    const fetchFieldType = (id) => {
      let result = null;

      module_data.value.forEach((module) => {
        const found = module.children.find((item) => item.id === id);
        if (found) {
          result = { fieldType: found.field_type, field: found.field, dropdown_options: JSON.parse(JSON.stringify(found.dropdown_options)) };
        }
      });

      return result;
    };

    const fetchReportData = async (id) => {
      try {
        formSubmitted.value = false;
        const data = await store.dispatch("report/fetchReportData", id);
        const settingsData = await store.dispatch(
          "report/fetchDropdownOptions"
        );
        settingField.value = settingsData;
        if(!data){
                    showFallback.value = true;
                    return
                }
        reportData.value = data || {}
        const updatedFilters = data.filters.map((group) => {
          return group.map((item) => {
            const fields = fetchFieldType(item.field_id);
            let newValue = item.value;
            let specialSelected;
            let adjustValue;

            // Convert ISO date string to Date object
            if (newValue && typeof newValue === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(newValue)) {
              newValue = new Date(newValue);
            }
            // Handle special cases when newValue is a string
            if (typeof newValue === "string") {
              if (newValue === "blank" || newValue === "current") {
                specialSelected = newValue;
              } else {
                const match = newValue.match(/^current([+-]\d+)$/);
                if (match) {
                  specialSelected = "currentAddjust";
                   adjustValue = parseInt(match[1], 10);
                }
              }
            }

            const row = {
              fieldType : fields?.fieldType || "none",
            }

            const filteredOptions = findCreteriaOptions(row)

            return {
              ...item,
              value: newValue,
              fieldType: fields.fieldType,
              field: fields.field,
              dropdown_options: fields.dropdown_options,
              specialSelected: specialSelected || 'spec_date',
              adjustValue: adjustValue || 0,
              special: false,
              criteria_options: filteredOptions
            };
          });
        });
        const updatedData = {
          ...data,
          filters: updatedFilters,
        };

        formData.value = updatedData || { filters: [] };
        if (formData.value.filters.length === 0) {
          formData.value.filters.push([
            {
              field_id: null,
              condition: "",
              value: "",
              prompt_user: false,
              fieldType: "none",
              field: '',
              specialSelected: 'spec_date',
              special: false,
              adjustValue: 0,
              criteria_options: {},
            },
          ]);
          treeselectKey.value++; // Force re-render
        }

        // const settingsData = await store.dispatch(
        //   "report/fetchDropdownOptions"
        // );
        // settingField.value = settingsData;
        const value = settingsData.modules.filter((item) => {
          return item.id === formData.value.module_id;
        })[0];
        filterData.value = { ...value };

        initialModuleValue.value = { ...value };
        await store.dispatch("report/saveReportDetails", {
          name: formData.value.name,
          module_name: initialModuleValue.value.name,
        });
        await nextTick();
      } catch (error) {
        console.error("Error fetching report data:", error);
      }
    };

    const addRowToGroup = (groupIndex) => {
      formSubmitted.value = false;
      formData.value.filters[groupIndex].push({
        field_id: null,
        condition: "",
        value: "",
        prompt_user: false,
        fieldType: "none",
        field: '',
        specialSelected: 'spec_date',
        special: false,
        adjustValue: 0,
        critera_options:{}
      });
    };

    const addGroup = () => {
      formSubmitted.value = false;
      formData.value.filters.push([
        {
          field_id: null,
          condition: "",
          value: "",
          prompt_user: false,
          fieldType: "none",
          field: '',
          specialSelected: 'spec_date',
          special: false,
          adjustValue: 0,
          critera_options:{}
        },
      ]);
    };

    const removeRow = (groupIndex, rowIndex) => {
      const row = formData.value.filters[groupIndex][rowIndex];
      if (formData.value.filters[groupIndex].length > 1) {
        formData.value.filters[groupIndex].splice(rowIndex, 1);
      } else if (
        formData.value.filters[groupIndex].length === 1 &&
        formData.value.filters.length > 1
      ) {
        formData.value.filters.splice(groupIndex, 1);
      } else {
        const fieldsAreEmpty = !row.field_id && !row.condition && !row.value;
        if (!fieldsAreEmpty) {
          row.field_id = null;
          row.condition = "";
          row.value = "";
          row.prompt_user = 0;
          row.fieldType = "none",
          specialSelected= 'spec_date',
          special= false,
          adjustValue= 0,
          row.critera_options={}
        }
      }
      formSubmitted.value = false;
    };

    // const handleSelectChange = (groupIndex, rowIndex, selectedNode) => {
    //   // const field = document.getElementsByClassName("vue-treeselect__single-value");
    //   // if (field?.[0]?.innerHTML) {
    //   //   field[0].innerHTML = selectedNode.label;
    //   // }
    //   formData.value.filters[groupIndex][rowIndex].fieldType = selectedNode.field_type;
    //   formData.value.filters[groupIndex][rowIndex].field = selectedNode.field;
    //   formData.value.filters[groupIndex][rowIndex].dropdown_options = selectedNode.dropdown_options;
    //   const row = formData.value.filters[groupIndex][rowIndex];
    //   if (row) {
    //     const criteriaOptions = settingField.value.critera_options;
    //     const key = Object.keys(criteriaOptions).find(
    //       (optionKey) => criteriaOptions[optionKey] === "Equal ( = )"
    //     );

    //     if (key) {
    //       row.condition = key;
    //       row.value = null
    //     }
    //   }
    // };

const findCreteriaOptions = (row) => {

   const allCriteriaOptions = settingField.value.critera_options;

    let filteredOptions = {};

     if (row.fieldType === "dropdown") {
      filteredOptions = {
        equal: allCriteriaOptions.equal,
        not_equal: allCriteriaOptions.not_equal,
        blank: allCriteriaOptions.blank,
        not_blank: allCriteriaOptions.not_blank
      };
    } else if (row.fieldType === "checkbox") {
      filteredOptions = {
        equal: allCriteriaOptions.equal,
        not_equal: allCriteriaOptions.not_equal,
      };
    } else if (row.fieldType === "textarea") {
      filteredOptions = Object.fromEntries(
        Object.entries(allCriteriaOptions).filter(
          ([key]) => key !== "greater_than" && key !== "less_than"
        )
      );
    } else if (row.fieldType === "datepicker") {
      filteredOptions = {
        equal: allCriteriaOptions.equal,
        not_equal: allCriteriaOptions.not_equal,
        greater_than: allCriteriaOptions.greater_than,
        less_than: allCriteriaOptions.less_than,
        blank: allCriteriaOptions.blank,
        not_blank: allCriteriaOptions.not_blank
      };
    }
     else {
      filteredOptions = allCriteriaOptions;
    }

    return filteredOptions;

}

const handleSelectChange = (groupIndex, rowIndex, selectedNode) => {
  formData.value.filters[groupIndex][rowIndex].fieldType = selectedNode.field_type;
  formData.value.filters[groupIndex][rowIndex].field = selectedNode.field;
  formData.value.filters[groupIndex][rowIndex].dropdown_options = selectedNode.dropdown_options;

  const row = formData.value.filters[groupIndex][rowIndex];
  if (row) {

    const filteredOptions =  findCreteriaOptions(row);
    row.criteria_options = filteredOptions;

    if (filteredOptions.equal) {
      row.condition = "equal";
    } else {
      row.condition = Object.keys(filteredOptions)[0] || null;
    }
    row.value = null;
  }
};


    const handleChartChange = (selectedNode) => {
      const field = document.getElementsByClassName("vue-treeselect__single-value");
      if (field?.[0]?.innerHTML) {
        field[0].innerHTML = selectedNode.label;
      }
    };

    const handleChange = async (event) => {
      event.preventDefault();
      const selectedOption = event.target.options[event.target.selectedIndex];
      const selectedId = selectedOption.id;
      const selectedValue = selectedOption.value;
      const reportId = route.query.reportId;
      selectedData.value = {
        id: reportId,
        name: formData.value.name,
        module_id: selectedId,
        filters: [],
      };

      const modal = new Modal(document.getElementById("confirm_modal"));
      modal.show();
    };

    const confirm_change = async () => {
      const response = await store.dispatch(
        "report/saveReportData",
        selectedData.value
      );
      if (response.status) {
        document.getElementById("close-btn").click();
        isEditing1.value = false;
        document.removeEventListener('click', handleClickOutside)
        const reportId = route.query.reportId;
        router.push({
          path: "/crm/report-edit",
          query: {
            reportId: reportId,
            moduleId: selectedData.value.module_id,
          },
        });
        // const field = document.getElementsByClassName("vue-treeselect__single-value");
        // if (field?.[0]?.innerHTML) {
        //   field[0].innerHTML = "";
        // }
      }
    };

    const cancel_change = async () => {
      document.getElementById("close-btn").click();

      filterData.value = { ...initialModuleValue.value };

      isEditing1.value = false;
      await store.dispatch("report/saveReportDetails", {
        name: formData.value.name,
        module_name: filterData.value.name,
      });
    };

    const handleReport = async () => {
      await handleSubmit(false);
      const reportId = route.query.reportId;
      const moduleId = route.query.moduleId;
      router.push({
        path: "/crm/overview/report",
        query: {
          modN: filterData.value.name,
          repN: formData.value.name,
          reportId: reportId,
          moduleId: moduleId,
        },
      });
    };

    const handleToggleFilter = () => {
      toggle.value = false;
    };

    const handleToggleChart = () => {
      toggle.value = true;
    };
    const handleDateChange = (date, row) => {
      if (date instanceof Date && !isNaN(date.getTime())) {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        row.value = localDate;
      }
    };

    const handleClickOutside = (event) => {
      if (selectWrapper.value && !selectWrapper.value.contains(event.target)) {
        isEditing1.value = false
        document.removeEventListener('click', handleClickOutside)
      }
    }

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    watch(async () => {
      const reportId = route.query.reportId;
      const moduleId = route.query.moduleId;
      await fetchModuleData(moduleId);
      await fetchReportData(reportId);
    });

    return {
      handleSubmit,
      report_id,
      isEditing,
      formData,
      store,
      route,
      router,
      addRowToGroup,
      addGroup,
      removeRow,
      handleSelectChange,
      settingField,
      selectedField,
      selectedCondition,
      filters,
      formSubmitted,
      isFormValid,
      togglePromptUser,
      toggleEdit,
      changeValue,
      selectedOption,
      isEditing1,
      settingData,
      filterData,
      handleChange,
      confirm_change,
      cancel_change,
      selectedData,
      handleReport,
      module_data,
      fetchModuleData,
      selectedModule,
      getModuleFields,
      value,
      handleToggleFilter,
      handleToggleChart,
      toggle,
      chart,
      fetchFieldType,
      // special,
      toggleSpecial,
      // specialSelected,
      adjustDate,
      // adjustValue,
      dateFormat,
      handleDateChange,
      handleChartChange,
      reportData,
      showFallback,
      selectWrapper,
      treeselectKey
    };
  },
};
</script>

<style scoped="true" lang="scss">
.is-invalid {
  margin-bottom: 5px;

  input,
  select {
    border: 1px solid #dc3545;
  }
}

.form-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

select {
  padding: 5px;
  width: 100%;
}

.close-btn {
  border: 1px solid red;
  background: #fff;
  border-radius: 50%;
  width: 25px;
  height: 25px;
}

.check-input {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
}

label {
  margin-left: 5px;
}

hr {
  border-top: 1px solid #ccc;
  margin-top: 10px;
  margin-bottom: 10px;
}

.select {
  text-transform: capitalize;
}

.confirm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.confirm-btn,
.cancel-btn {
  width: 70%;
  margin-bottom: 20px;
}

.custom_form_select {
  min-height: 37px;
  max-height: 37px;
  box-shadow: none;
  border: 1px solid #ddd;
}

.report-btn {
  margin-right: 20px;
  padding: 9px 19px;
}

.cross-btn {
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #fc0027;
}

.icon-form .v3dp__datepicker .v3dp__input_wrapper {
  height: 37px;
}

.py-3-5 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem
}
</style>
